<template>
  <v-row v-if="course">
    <v-col sm="12" class="pb-0">
      <div>
        <tr>
          <td>
            <v-card-title class="pb-0 pl-0 pr-4">
              <h3>{{ course.title }}</h3>
            </v-card-title>
          </td>
          <td>
            <v-card-subtitle class="pb-0">
              {{ $tc('course.videosInCourse', progression, { total: filteredVideos.length }) }}
            </v-card-subtitle>
          </td>
        </tr>

        <v-card-actions @click="show = !show" class="pt-2 py-1 pl-0">
          <!-- <v-btn color="pink lighten-2" text> Description </v-btn> -->
          <v-btn
            rounded
            outlined
            color="#bbbbc8"
            height="20px"
            style="opacity: 0.8"
            dark
            justify-content="center"
            >{{$t('common.detail')}}</v-btn>
          <!-- <v-spacer></v-spacer> -->

          <v-btn icon height="20px" width="20px">
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <div v-show="show">
            <v-card-text class="pt-0 pb-2 pl-2">
              <div>
                {{ course.description }}
              </div>
            </v-card-text>
          </div>
        </v-expand-transition>

        <v-divider></v-divider>
      </div>
    </v-col>
    <v-col sm="12" class="px-4 py-0">
      <vue-horizontal v-if="filteredVideos.length > 0">
        <div
            v-for="video in filteredVideos"
            :key="video.id"
            class="my-1 mr-3"
            style="width: 200px; min-height: 200px;"
        >
          <video-card
              :video="video"
              :router-link-to="{ name: 'videoFromCourse', params: { id: video.id, idParcours: course.id } }"
          ></video-card>
        </div>
      </vue-horizontal>
    </v-col>
  </v-row>
</template>

<script>
import VueHorizontal from "vue-horizontal";
import VideoCard from "@/components/video/videoCard";
import Api from "@/core/services/api.service";
import store from "@/core/services/store";
import {mapGetters} from "vuex";
import {courseProgression} from "@/core/utils/course";

export default {
  name: "courseItem",
  components: { VueHorizontal, VideoCard },
  data: () => ({
    show: false,
    videos: []
  }),
  props: {
    course: Object,
  },
  computed: {
    ...mapGetters(["currentUser"]),
    progression() {
      return courseProgression(this.currentUser, this.videos);
    },
    filteredVideos() {
      // Ne pas afficher les vidéos non visibles si l'utilisateur n'est pas administrateur
      return store.getters.isAdmin ? this.videos : this.videos.filter(v => v.isVisible);
    }
  },
  mounted() {
    // Vérifier si le parcours contient bien toutes les données nécessaires
    if (typeof this.course.videos === 'undefined'
        || !Array.isArray(this.course.videos)
        || typeof this.course.videos[0] === 'string'
        || typeof this.course.videos[0] === 'undefined'
        || typeof this.course.videos[0].title === 'undefined'
    ) {
      Api.get('courses', this.course.id)
        .then(response => {
          this.videos = response.data.videos;
        })
      ;
    } else {
      this.videos = this.course.videos;
    }
  }
};
</script>



